import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=cbf5d852&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"
import style0 from "./ProjectOverview.vue?vue&type=style&index=0&id=cbf5d852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf5d852",
  null
  
)

export default component.exports